import { useNativeBridge } from './useNativeBridge';

export namespace Push {
    export interface DoNRequestAppDBRequest {
        dbName?: string;
        query: {
            [query: string]: string;
        };
        type: string;
    }

    export interface DoNRequestAppDBResponse {
        data: unknown;
    }

    export interface DoNGetPushServiceResponse {
        token: string;
    }
}

/**
 * PUSH 관련 네이티브 브릿지 hook
 */
const usePushBridge = () => {
    const nativeBridge = useNativeBridge();

    /**
     *
     */
    const doNRequestAppDB = async (request: Push.DoNRequestAppDBRequest) => {
        const payload: Push.DoNRequestAppDBRequest = {
            ...request,
            dbName: request.dbName ?? 'MA3_APP_PUSHMSG',
        };
        const res = await nativeBridge<Push.DoNRequestAppDBRequest, Push.DoNRequestAppDBResponse>(
            'doNRequestAppDB',
            payload,
        );

        if (res.status === 'fail') {
            return;
        }
        return res.payload;
    };

    /**
     * PUSH서비스 관련 토큰 획득
     * @returns
     */
    const doNGetPushService = async (): Promise<string | undefined> => {
        const res = await nativeBridge('doNGetPushService');

        if (res.status === 'fail') {
            return;
        }

        const payload = res.payload as Push.DoNGetPushServiceResponse;
        const deviceToken = decodeURIComponent(payload.token);
        return deviceToken;
    };

    return {
        doNRequestAppDB,
        doNGetPushService,
    };
};

export { usePushBridge };
